import {downloadFile} from '@domain/file-download'
import {spawnErrorToast} from '@hm/fundamental'
import {useMutation} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {downloadPlantSubmissions} from '../../common/backend/plant'
import {FEATURE_NAMESPACE} from '../../consts'

export const usePlantSubmissionDownload = (plantId: string) => {
  const {t} = useTranslation(FEATURE_NAMESPACE)

  return useMutation({
    mutationFn: () => downloadPlantSubmissions(plantId),
    onSuccess: (blob: Blob) => {
      downloadFile(blob, `${plantId}_submissions.xlsx`)
    },
    onError: () => {
      spawnErrorToast(t('errors.excelDownloadFailed'))
    }
  })
}
